import { AfterContentInit, ComponentRef, Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PermissionWrapperComponent } from '../components/permission-wrapper.component';
import { PERMISSIONS, PERMISSION_ACCESS } from '../enums/permissions.enum';
import { PermissionsService } from '../services/permissions.service';

@Directive({
    standalone: false, selector: '[hasAccess]' })
export class PermisionsDirective implements AfterContentInit {
    @Input()
    hasAccess!: PERMISSIONS

    @Input()
    hasAccessLevel: PERMISSION_ACCESS.ADMIN | PERMISSION_ACCESS.WRITE | PERMISSION_ACCESS.READ | PERMISSION_ACCESS.DEV_USER = PERMISSION_ACCESS.ADMIN;

    @Input()
    hasAccessHide: boolean = true;

    private $observable!: Observable<boolean>
    private container!: ComponentRef<PermissionWrapperComponent>;

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainerRef: ViewContainerRef,
        private permissionsService: PermissionsService
    ) { }

    ngAfterContentInit() {
        this.viewContainerRef.clear();
        switch(this.hasAccessLevel) {
            case PERMISSION_ACCESS.ADMIN:
                this.$observable = this.permissionsService.hasAdmin(this.hasAccess)
                break
            case PERMISSION_ACCESS.WRITE:
                this.$observable = this.permissionsService.hasWrite(this.hasAccess)
                break
            case PERMISSION_ACCESS.READ:
                this.$observable = this.permissionsService.hasRead(this.hasAccess)
                break
            case PERMISSION_ACCESS.DEV_USER: 
                this.$observable = this.permissionsService.isDevUser()
                break
        }

        this.$observable.subscribe(hasAccess => {
            if (hasAccess) {
                setTimeout(() => {
                    const viewRef = this.viewContainerRef.createEmbeddedView(this.templateRef);
                    viewRef.detectChanges();
                });
            } else {
                if (this.hasAccessHide) {
                    this.viewContainerRef.clear();
                } else {
                    this.container = this.viewContainerRef.createComponent(PermissionWrapperComponent);
                    this.container.instance.template = this.templateRef;
                    this.container.changeDetectorRef.detectChanges();
                }
            }
        });
    }
}